import "@fontsource-variable/figtree";
import "@fontsource-variable/sour-gummy";
import "@fontsource-variable/caveat";
import "../styles/index.scss";

import {initMenu} from "./modules/menu";
import {initStickyHeader} from "./modules/header";
import {initLightbox} from "./modules/lightbox";
import {initContactForms} from "./modules/contact-form";
import {initPlanLinks} from "./modules/plan-links";
import {initInstagram} from "./modules/instagram";
import {initAnalytics} from "./modules/analytics";
import {initMotion} from "./motion";

class Main {
    constructor() {
        this.onDOMLoaded();
    }

    onDOMLoaded() {
        const start = () => {
            initMenu();
            initStickyHeader();
            initLightbox();
            initContactForms();
            initPlanLinks();
            initInstagram();
            initAnalytics();
            initMotion();
        };
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", start);
        } else {
            start();
        }
    }
}

new Main();
